module.exports = __webpack_public_path__ + "static/img/Lotary-Operations-Rgh.e621e62.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/medias/images/Sectors/Lotary-Operations-Rgh.png
// module id = V2yE
// module chunks = 1